// src/components/common/NavButton.jsx
import React from 'react';

const NavButton = ({ icon, isActive, onClick }) => (
  <div 
    className={`flex flex-col items-center cursor-pointer p-1 ${isActive ? 'text-green-600' : 'text-gray-400'}`}
    onClick={onClick}
  >
    {icon}
    {isActive && <div className="w-1 h-1 bg-green-600 rounded-full mt-1"></div>}
  </div>
);

export default NavButton;